import { render, staticRenderFns } from "./TourStartButton.vue?vue&type=template&id=5090a5a3&"
import script from "./TourStartButton.vue?vue&type=script&lang=js&"
export * from "./TourStartButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports